import React from 'react';

import classnames from 'clsx';

import { ChildrenPropType } from '../../../../prop-types/children';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import { useOtherShippingOptionsStyleContext } from '../../style-provider';

import style from '../../other-shipping-options.module.css';

export const ReadOnlyRow = ({ children, title }) => {
  const { classes } = useOtherShippingOptionsStyleContext();

  return (
    <div className={classnames(style['read-only-row'], classes.readonlyRow)}>
      <div className={classnames(style['read-only-title'], classes.sectionTitle)}>{title}</div>
      <div className={classnames(style['read-only-value-section'], classes.readonlyValueSection)}>{children}</div>
    </div>
  );
};

ReadOnlyRow.propTypes = {
  children: ChildrenPropType.isRequired,
  title: FormattedMessagePropType.isRequired,
};
